import { FORMAT, format } from 'utils/date';

export default ({ isSlotBooked, slotDate, slotStartTime, shortTime } = {}) => {
  if (isSlotBooked && slotDate && slotStartTime) {
    let formattedData = `${format(slotDate, FORMAT.SHORT_2DAY_MONTH)}`;

    if (shortTime) {
      formattedData = `${format(slotDate, FORMAT.SHORT_DAY)}`;
    }

    return formattedData;
  }
  return 'Book a slot';
};
